import { oz } from '@weft/utils';
import { ObjectIdSchema } from '../../../primitives';

export const SalesforceMeshContractSchema = oz.object({
  Id: oz.string(),
  Org_Account__r: oz.object({
    Id: oz.string(),
    Name: oz.string(),
    Number_of_Users_Units__c: oz.number(),
    Monthly_Fees_Per_User__c: oz.number(),
    Package__c: oz.string(),
  }),
}).openapi('SalesforceMeshContract');

export type SalesforceMeshContract = oz.infer<typeof SalesforceMeshContractSchema>;

export const SalesforceMeshContractWithCustomerSchema = SalesforceMeshContractSchema.extend({
  vayuCustomerId: ObjectIdSchema,
}).openapi('SalesforceMeshContractWithCustomer');

export type SalesforceMeshContractWithCustomer = oz.infer<typeof SalesforceMeshContractWithCustomerSchema>;